import { useState, useEffect, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import {
  requestSignUp,
  requestSmsCode,
  requestLogin,
  getUserInfo,
} from "@/services/api";
import SignUpRender from "./children/SignupRender";
import Cookies from "js-cookie";
import api_domain_config from "@/config/config";
import { connect } from "react-redux";
import actions from "@/redux/action";
import { GASignUpPageDisplay, GASignUpFromError } from "@/ga/signUp";
// import SliderCaptch from '../../components/SliderCaptcha';
import "./index.less";

const SignUp = (props) => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [linkToPersonalCenter, setLinkToPersonalCenter] = useState(false); //是否跳转个人中心页面
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isShowCode, setIsShowCode] = useState(false);
  const [time, setTime] = useState(60);
  const userPhone = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    //埋点
    GASignUpPageDisplay();
    document.title = "牛学长账号注册-个人中心";
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", "牛学长账号注册");
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", "牛学长账号注册");

    //判断当前登录状态
    if (Cookies.get("authorization")) {
      //跳转登录页面
      navigate("/personal-center", { replace: true });
    }
  }, []);

  // 获取短信验证码
  const sendCode = async (phone) => {
    if (isShowCode) {
      // 倒计时未结束,不能重复点击
      return;
    }
    // setIsModalVisible(true);
    // userPhone.current = phone;
    const params = {
      type: 1,
      scene: 1,
      phone: phone,
      brand_id: 7,
    };
    const { code } = await requestSmsCode(params);
    if (code === 200) {
      setIsShowCode(true);
      // 倒计时
      const active = setInterval(() => {
        setTime((preSecond) => {
          if (preSecond <= 1) {
            setIsShowCode(false);
            clearInterval(active);
            // 重置秒数
            return 60;
          }
          return preSecond - 1;
        });
      }, 1000);
      setIsModalVisible(false);
    }
  };

  //滑动验证码验证成功调获取验证码接口
  // const handerSuccess = async () => {
  //     if (isShowCode) { // 倒计时未结束,不能重复点击
  //         return;
  //     }
  //     setIsShowCode(true);
  //     document.querySelector('.verify-bar .icon').classList.add('icon-success');
  //     const params = {
  //         type: 1,
  //         scene: 1,
  //         phone: userPhone.current,
  //         brand_id: 7
  //     }
  //     const {code} = await requestSmsCode(params);
  //     if(code === 200){
  //         // 倒计时
  //         const active = setInterval(() => {
  //             setTime((preSecond) => {
  //                 if (preSecond <= 1) {
  //                     setIsShowCode(false)
  //                     clearInterval(active)
  //                     // 重置秒数
  //                     return 60;
  //                 }
  //                 return preSecond - 1;
  //             })
  //         }, 1000)
  //         setIsModalVisible(false)
  //     }
  // }

  // 提交表单数据
  const handleRequestSignUp = async (params) => {
    setSubmitLoading(true);
    delete params.agreement;
    params = { brand_id: 7, ...params };
    const { code, msg } = await requestSignUp(params);
    if (code === 200) {
      setSubmitLoading(false);
      //注册成功后默认登录
      handleRequestLogin({
        username: params.username,
        password: params.password,
      });
      //存储用户已注册过标识
      localStorage.setItem("isSignin", "yes");
    } else {
      setSubmitLoading(false);
      GASignUpFromError(msg);
    }
  };

  //登录
  const handleRequestLogin = async (params) => {
    let newParams = {
      client_id: api_domain_config.CLIENT_ID,
      client_secret: api_domain_config.CLIENT_SECTET,
      brand_id: 7,
      grant_type: "password",
      ...params,
    };
    const { code, data } = await requestLogin(newParams);
    if (code === 200 && data) {
      props.onAuthorizationChange(data.access_token);
      //将当前auth存在顶级域名cookies底下
      Cookies.set("authorization", data.access_token, {
        expires: 30,
        domain: api_domain_config.DOMAIN,
      });
      handleLoginRedirect();
    }
  };

  /**
   *控制用户登录完毕登录后的跳转链接
   */
  const handleLoginRedirect = async () => {
    //登录成功之后应该获取当前用户信息，再返回到当前的购买页，否则拿不到用户的信息
    const { code, data } = await getUserInfo();
    if (code === 200) {
      //保存当前的用户信息
      localStorage.setItem("currentUserInfo", JSON.stringify(data));
    }
    if (
      localStorage.getItem("currentUserInfo") &&
      sessionStorage.getItem("backLink")
    ) {
      const backLink = sessionStorage.getItem("backLink");
      window.location.replace(backLink);
    } else {
      //跳转到个人中心页面
      setLinkToPersonalCenter(true);
    }
  };

  return (
    <>
      {linkToPersonalCenter && (
        <Navigate to="/personal-center/product-list" replace={true} />
      )}
      <SignUpRender
        handleRequestSignUp={handleRequestSignUp}
        sendCode={(phone) => sendCode(phone)}
        isShowCode={isShowCode}
        time={time}
        submitLoading={submitLoading}
        urlSearch={props.urlSearch}
      />
      {/* <SliderCaptch 
                isModalVisible={isModalVisible}
                handleCancel={() => setIsModalVisible(false)}
                handerSuccess={handerSuccess}
            /> */}
    </>
  );
};

//这个函数允许我们将store中的数据作为props绑定到组件上,当state变化时,函数被调用
const mapStateToPropos = (state) => ({
  authorization: state.account.authorization,
});

//将action作为props绑定在当前组件上
const mapDispatchToProps = (dispatch) => ({
  onAuthorizationChange: (authorization) =>
    dispatch(actions.onAuthorizationChange(authorization)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(SignUp);
